<mat-toolbar class="fixed z-10 md:z-0 md:relative compact">
  <mat-toolbar-row>
    @if (hasMenu$ | async) {
      <button (click)="onOpenAppMenu()" class="mr-2" [title]="'frame.menu' | transloco"
              id="all_toolbar_btn_open-application-menu"
              mat-icon-button>
        <mat-icon class="fill">menu</mat-icon>
      </button>
    }

    @if (titleLogoMode === 'logo_left' || titleLogoMode === 'only_logo') {
      <div class="mr-2 h-full">
        <fr-logo [lang]="currentLang" [logo]="logo" classes="flex" htmlId="frame-logo"></fr-logo>
      </div>
    }

    @if (titleLogoMode !== 'only_logo') {
      <div class="md:inline-block hidden" id="all_toolbar_txt_application-title">
        {{ title[currentLang] }}
      </div>
    }

    @if (showBetaTag) {
      <span
        class="beta-tag ml-2 hidden md:block mat-label-small rounded-xl px-2"
      >
        BETA
      </span>
    }


    @if (titleLogoMode === 'logo_right') {
      <fr-logo [lang]="currentLang" [logo]="logo" classes="flex" htmlId="frame-logo"></fr-logo>
    }

    <span class="flex-auto"></span>

    @if (logos) {
      <div class="h-full flex">
        @for (logo of logos; track logo; let index = $index) {
          <fr-logo
            [classes]="index > 0 ? 'hidden md:flex' : 'flex'"
            [lang]="currentLang"
            [logo]="logo"
          ></fr-logo>
        }
      </div>
    }

    <span class="flex-auto"></span>

    <fr-overlay-manager-button (action)="onOpenOverlayManager()"
    ></fr-overlay-manager-button>
    <fr-personal-content-plugin-button
      (action)="togglePersonalContentPlugin.emit()"
    ></fr-personal-content-plugin-button>
    <fr-personal-content-button
      [hasPersonalContent]="hasPersonalContent"
      [isLoggedIn]="isLoggedIn$ | async"
      [isPersonalContentEnabled]="isPersonalContentEnabled"
      [username]="username$ | async"
    ></fr-personal-content-button>
    <fr-coop-messages-button (action)="onOpenOverlay(coopFeed)" [hasPersonalContent]="hasPersonalContent"
                             [isLoggedIn]="isLoggedIn$ | async"
                             [isPersonalContentEnabled]="isPersonalContentEnabled"></fr-coop-messages-button>
    <fr-language-button
      (changeLanguage)="onChangeLanguage($event)"
      [currentLanguage]="currentLanguage$ | async"
      [languages]="languages"
    ></fr-language-button>

    @if (instructionsUrl) {
      <button

        (click)="onInstruction(instructionsUrl)"
        [title]="'ui.titles.instructions' | transloco"
        id="all_toolbar_btn_open-help"
        mat-icon-button
      >
        <mat-icon class="fill">help</mat-icon>
      </button>
    }

    @if (isLoggedIn$ | async) {
      <fr-logout-button (action)="onLogout()"></fr-logout-button>
    } @else {
      <fr-login-button (action)="onLogin()"></fr-login-button>
    }
  </mat-toolbar-row>
</mat-toolbar>

<ng-template #coopFeed>
  <fr-coop-messages></fr-coop-messages>
</ng-template>
